/**
 * Viewport-pane cycling for the hanging-protocol grid.
 *
 * Tab is reserved for editor/suggestion-strip navigation (#404) and the arrow
 * keys navigate cases, so the "V" hotkey cycles the active viewport pane. This
 * pure helper picks the next pane to activate.
 */

/**
 * Given the populated slots in display order and the current active slot,
 * return the next populated slot, wrapping around. Returns the first populated
 * slot if `current` isn't in the list, and null if nothing is populated.
 */
export function nextVisibleSlot(orderedVisibleSlots: string[], current: string): string | null {
  if (orderedVisibleSlots.length === 0) return null;
  const i = orderedVisibleSlots.indexOf(current);
  if (i === -1) return orderedVisibleSlots[0];
  return orderedVisibleSlots[(i + 1) % orderedVisibleSlots.length];
}
